class MiniCartFreeShipping extends MiniCartPlugin {
  constructor(miniCartParent, params) {
    super(miniCartParent || params);
    this.pluginName = "FreeShipping";
    this.params = {
      freeShippingAmount: (parseInt(params.freeShippingAmount) || 150) * 100,
      remainigLabel: params.remainigLabel || 'Free shipping over %freeshiping_amount%! You need %remaining% to qualify for free shipping.',
      qualifiedLabel: params.qualifiedLabel || 'You qualify for free shipping!',
    };
    this.htmlSelectors = {
      bar: 'hc-free-shipping-bar',
      text: 'hc-free-shipping-text',
      container: 'hc-free-shipping-conatainer'
    };
    this.jsSelectors = {
      bar: '[hc-free-shipping-bar]',
      text: '[hc-free-shipping-text]',
      container: '[hc-free-shipping-conatainer]'
    };
  }
  _updateOn(cart, oldCart, selectors, update) {
    if ((cart.total_price > 0) !== (oldCart.total_price > 0)) {
      update(selectors.container);
    } else if (cart.total_price !== oldCart.total_price) {
      update(selectors.bar);
      update(selectors.text)
    }

  }
  ctx(cart, globalCtx) {
    const remaining_amount = this.params.freeShippingAmount - cart.total_price;
    const remaining_percent = (cart.total_price / this.params.freeShippingAmount * 100);
    const formatMoney = (Shopify && Shopify.formatMoney) || (theme && theme.Currency && theme.Currency.formatMoney);
    if (!formatMoney) throw Error(`There's no price formating function available`);
    return {
      total_price: formatMoney(cart.total_price, globalCtx.formatPriceOptions),
      remaining_amount: formatMoney(remaining_amount, globalCtx.formatPriceOptions),
      remaining_percent,
      freeshiping_amount: formatMoney(this.params.freeShippingAmount)
    }
  }
  _template(ctx) {
    return `
<div ${ctx.selectors.container} class="hc-mini-cart--free-shiping-container" style="${ctx.cart.total_price > 0 ? "" : "display: none;"}">
<span ${ctx.selectors.text} class="hc-mini-cart--free-shipping-amount ${(ctx.cart.total_price >= this.params.freeShippingAmount && 'hc-free-shipping-icons') || ''}">
<span>
${ctx.cart.total_price < this.params.freeShippingAmount
    ? this.params.remainigLabel.replace('%freeshiping_amount%', ctx.freeshiping_amount).replace('%remaining%', ctx.remaining_amount)
    : this.params.qualifiedLabel.replace('%freeshiping_amount%', ctx.freeshiping_amount).replace('%remaining%', ctx.remaining_amount)
  }
</span>
</span>
<div class="hc-mini-cart--free-shipping-bar">
<div id="hc-bar-fill" ${ctx.selectors.bar} style="--percent: ${ctx.remaining_percent >= 100 ? 100 : ctx.remaining_percent}%"></div>
</div>
</div>
`;
  }
}